import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PathioBuddies = () => {
  useEffect(() => {
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  useEffect(() => {
    const initAccordion = () => {
      const accordionContainers = document.querySelectorAll(".ul-accordion");
      accordionContainers.forEach(accordionContainer => {
        const accordionItems = accordionContainer.querySelectorAll(".ul-single-accordion-item");
        accordionItems.forEach((accordionItem) => {
          if (accordionItem.hasAttribute('data-accordion-initialized')) {
            return;
          }
          accordionItem.setAttribute('data-accordion-initialized', 'true');
          const header = accordionItem.querySelector(".ul-single-accordion-item__header");
          if (header) {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              const openedItems = accordionContainer.querySelector(".ul-single-accordion-item.open");
              if (accordionItem.classList.contains("open")) {
                accordionItem.classList.remove("open");
              } else {
                accordionItem.classList.add("open");
                if (openedItems && openedItems !== accordionItem) {
                  openedItems.classList.remove("open");
                }
              }
            });
          }
        });
      });
    };
    initAccordion();
    const timeoutId = setTimeout(initAccordion, 100);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />
      <main>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Pathio Buddies</h2>
            <ul className="ul-breadcrumb-nav">
              <li><Link to="/">Home</Link></li>
              <li><span className="separator"><i className="flaticon-right"></i></span></li>
              <li>Pathio Buddies</li>
            </ul>
          </div>
        </section>

        <section className="ul-section-spacing">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 gy-4 align-items-center">
              <div className="col">
                <div className="ul-why-join-img">
                  <img src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg" alt="Pathio Buddies Mentorship" />
                </div>
              </div>
              <div className="col">
                <div className="ul-why-join-txt" style={{paddingLeft: 'clamp(20px, 2.1vw, 40px)'}}>
                  <span className="ul-section-sub-title">Peer-to-Peer Mentorship</span>
                  <h2 className="ul-section-title">Pathio Buddies: Connecting Students on Healthcare Career Pathways</h2>
                  <p className="ul-section-descr">Pathio Buddies is Pathio's peer-to-peer mentorship program designed to connect students navigating healthcare career pathways with peers who are further along in similar journeys.</p>
                  <p className="ul-section-descr">The program focuses on shared experience, honest conversation, and consistent support. Mentors offer perspective, encouragement, and insight based on their own paths, helping mentees think through academic choices, college navigation, and healthcare career exploration.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-section-spacing pt-0" style={{background: 'var(--ul-gray3)'}}>
          <div className="ul-container">
            <div className="ul-section-heading text-center mb-5">
              <span className="ul-section-sub-title">Who This Program Is For</span>
              <h2 className="ul-section-title">Find Your Path, Share Your Journey</h2>
            </div>
            <div className="row row-cols-md-2 row-cols-1 gy-4">
              <div className="col">
                <div className="ul-service ul-service--inner" style={{height: '100%', background: 'var(--white)', padding: 'clamp(30px, 3.15vw, 50px)', borderRadius: 'clamp(15px, 1.05vw, 20px)'}}>
                  <div className="ul-service-txt">
                    <div className="ul-service-icon" style={{width: 'clamp(60px, 4.21vw, 80px)', height: 'clamp(60px, 4.21vw, 80px)', background: 'var(--ul-primary)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 'clamp(20px, 2.1vw, 30px)'}}>
                      <span style={{fontSize: 'clamp(28px, 2.1vw, 36px)'}}>👤</span>
                    </div>
                    <h3 className="ul-service-title" style={{marginBottom: 'clamp(15px, 1.58vw, 20px)'}}>For Mentees</h3>
                    <p className="ul-service-descr">High school and undergraduate students exploring healthcare-related careers or college in general. Students seeking guidance, perspective, and support from peers who understand their journey.</p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="ul-service ul-service--inner" style={{height: '100%', background: 'var(--white)', padding: 'clamp(30px, 3.15vw, 50px)', borderRadius: 'clamp(15px, 1.05vw, 20px)'}}>
                  <div className="ul-service-txt">
                    <div className="ul-service-icon" style={{width: 'clamp(60px, 4.21vw, 80px)', height: 'clamp(60px, 4.21vw, 80px)', background: 'var(--ul-primary)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 'clamp(20px, 2.1vw, 30px)'}}>
                      <i className="flaticon-team" style={{color: 'var(--white)', fontSize: 'clamp(24px, 1.58vw, 32px)'}}></i>
                    </div>
                    <h3 className="ul-service-title" style={{marginBottom: 'clamp(15px, 1.58vw, 20px)'}}>For Mentors</h3>
                    <p className="ul-service-descr">Students further along in their healthcare career journey who are willing to commit time, listen thoughtfully, and share lived experience to help guide the next generation of healthcare professionals.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-section-spacing">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 gy-4 align-items-center">
              <div className="col order-md-2">
                <div className="ul-why-join-img">
                  <img src="/assets/new-img/young-diverse-people-having-fun-outdoor-laughing-t-2025-10-14-07-40-19-utc.jpg" alt="How Pathio Buddies Works" />
                </div>
              </div>
              <div className="col order-md-1">
                <div className="ul-why-join-txt" style={{paddingRight: 'clamp(20px, 3.15vw, 50px)'}}>
                  <span className="ul-section-sub-title">How It Works</span>
                  <h2 className="ul-section-title">Simple Process, Meaningful Connections</h2>
                  <div className="ul-accordion" style={{marginTop: 'clamp(25px, 2.63vw, 35px)'}}>
                    <div className="ul-single-accordion-item open">
                      <div className="ul-single-accordion-item__header">
                        <div className="left"><h3 className="ul-single-accordion-item__title">Apply</h3></div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>
                      <div className="ul-single-accordion-item__body">
                        <p>Students apply as mentors or mentees through a short application form. Share your interests, experience, and what you're looking for in a mentorship relationship.</p>
                      </div>
                    </div>
                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left"><h3 className="ul-single-accordion-item__title">Get Matched</h3></div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>
                      <div className="ul-single-accordion-item__body">
                        <p>Matches are made intentionally based on interests, experience, and preferences. We take time to ensure meaningful connections that benefit both mentors and mentees.</p>
                      </div>
                    </div>
                    <div className="ul-single-accordion-item">
                      <div className="ul-single-accordion-item__header">
                        <div className="left"><h3 className="ul-single-accordion-item__title">Connect & Grow</h3></div>
                        <span className="icon"><i className="flaticon-next"></i></span>
                      </div>
                      <div className="ul-single-accordion-item__body">
                        <p>Mentor–mentee pairs are expected to connect consistently for a minimum of 6 months. Build relationships, share experiences, and grow together on your healthcare career journeys.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-section-spacing pt-0">
          <div className="ul-container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div
                  className="ul-service-details-inner-block"
                  style={{
                    background: 'linear-gradient(135deg, var(--ul-primary) 0%, var(--ul-secondary) 100%)',
                    padding: 'clamp(50px, 5.26vw, 80px) clamp(30px, 3.15vw, 50px)',
                    borderRadius: 'clamp(15px, 1.58vw, 25px)',
                    color: 'var(--white)',
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  <span 
                    className="ul-section-sub-title" 
                    style={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      display: 'block',
                      marginBottom: 'clamp(15px, 1.58vw, 20px)',
                      fontSize: 'clamp(14px, 0.95vw, 16px)',
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase'
                    }}
                  >
                    Ready to Get Started?
                  </span>
                  <h2 
                    className="ul-section-title" 
                    style={{
                      color: 'var(--white)',
                      marginBottom: 'clamp(20px, 2.1vw, 30px)',
                      fontSize: 'clamp(28px, 2.63vw, 40px)',
                      fontWeight: 700
                    }}
                  >
                    Join Pathio Buddies Today
                  </h2>
                  <p 
                    className="ul-section-descr" 
                    style={{
                      color: 'rgba(255, 255, 255, 0.95)',
                      maxWidth: '650px',
                      margin: '0 auto clamp(40px, 4.21vw, 60px)',
                      fontSize: 'clamp(16px, 1.05vw, 18px)',
                      lineHeight: 1.7
                    }}
                  >
                    Whether you're looking for guidance or ready to share your experience, Pathio Buddies connects students who understand each other's journeys.
                  </p>
                  
                  <div className="row row-cols-md-2 row-cols-1 gy-3 justify-content-center" style={{maxWidth: '600px', margin: '0 auto'}}>
                    <div className="col">
                      <a 
                        href="https://forms.gle/HyYoUAQFKp9yUG1v8" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="ul-btn" 
                        style={{
                          width: '100%',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 'clamp(10px, 1.05vw, 14px)',
                          background: 'var(--white)',
                          color: 'var(--ul-primary)',
                          padding: 'clamp(16px, 1.68vw, 22px) clamp(30px, 3.15vw, 45px)',
                          fontSize: 'clamp(15px, 1.05vw, 17px)',
                          fontWeight: 600,
                          borderRadius: 'clamp(8px, 0.84vw, 12px)',
                          transition: 'all 0.3s ease',
                          textDecoration: 'none',
                          border: 'none'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        <i className="flaticon-team"></i> 
                        <span>Apply as a Mentor</span>
                      </a>
                    </div>
                    <div className="col">
                      <a 
                        href="https://forms.gle/djVTouhQ1wHx4cxW7" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="ul-btn" 
                        style={{
                          width: '100%',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 'clamp(10px, 1.05vw, 14px)',
                          background: 'rgba(20, 180, 180, 0.3)',
                          color: 'var(--white)',
                          padding: 'clamp(16px, 1.68vw, 22px) clamp(30px, 3.15vw, 45px)',
                          fontSize: 'clamp(15px, 1.05vw, 17px)',
                          fontWeight: 600,
                          borderRadius: 'clamp(8px, 0.84vw, 12px)',
                          transition: 'all 0.3s ease',
                          textDecoration: 'none',
                          border: '2px solid rgba(20, 180, 180, 0.5)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'rgba(20, 180, 180, 0.4)';
                          e.currentTarget.style.borderColor = 'rgba(20, 180, 180, 0.7)';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(20, 180, 180, 0.3)';
                          e.currentTarget.style.borderColor = 'rgba(20, 180, 180, 0.5)';
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        <div style={{width: 'clamp(20px, 1.58vw, 24px)', height: 'clamp(20px, 1.58vw, 24px)', background: 'var(--white)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <span style={{fontSize: 'clamp(12px, 0.95vw, 14px)'}}>👤</span>
                        </div>
                        <span>Apply as a Mentee</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PathioBuddies;
